import K9TableModuleBase from "./k9_talbe_module_base";
import { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import K9TableView from "./k9_talbe_View";
import K9TableModel from "./k9_talbe_model";
import { K9Proto } from "../../net/proto/proto_k9_game";
import ModuleManager from "../../../../framework/core/module_manager";
import BankerListModule from "../../../table/module/bankerlist/bankerlist_module";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import LanguageManager from "../../../../manager/language_manager";
import ModelData from "../../../public/model_data";
import { K9Room } from "../../net/proto/proto_k9_room";
import SceneManager from "../../../../manager/scene_manager";
import { K9 } from "./k9_data";
import K9Help from "./component/k9_help";
import K9SeatEntityBase from "./k9_seat_entity_base";
import K9Sound from "./component/k9_sound";
import EventManager from "../../../../manager/event_manager";
import { joinUtil } from "../../../public/join_util";
import DialogLeave from "../../../public/module/dialog_leave/dialog_leave";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('K9TableModule')
export default class K9TableModule extends K9TableModuleBase {
    constructor(){
        super();
        this.windowPrefabResPath = 'package/k9/module/k9_table';
        this.viewType = K9TableView;
        this.modelType = K9TableModel;
    }

    onInit(){
        super.onInit();
    }

    onShow(){
        super.onShow();
        this.registerUIEvent();
        K9Sound.playBg();
    }

    protected registerUIEvent(){
        this.eventBind("event_exit_game",()=>{
            let data = this.getMySeatData();
            this.model.send_Leave();
            if (data.state == K9.PlayerState.NoInGame
                || data.state == K9.PlayerState.Settlement) {
                
            }else{
                ModuleManager.instance.showModule(DialogLeave)
                // let text = LanguageManager.t("public_cannotLeave", true);
                // ModuleManager.instance.showModuleName("Toast",{text : text,long : true});
            }
        });

        this.eventBind("event_req_banker", this.requestHoldBanker);
    }

    protected requestHoldBanker(){
        let isInQueue = this.isInQueue()
        if (!isInQueue) {//申请上庄
            let rule = ModelData.instance.roomInfo.PlayRuleData;
            if (rule) {
                let data = this.getMySeatData();
                if (data) {
                    if (data.coin_balance < rule.pub_BeDealerLimit) {//金币不够
                        this.noEnoughGold();
                    }else if (this.meIsBank()) {//我已经是庄家
                        ModuleManager.instance.toast(LanguageManager.t('k9_isBanker',true));
                    }
                }
            }
        }
        this.model.send_Banker(!isInQueue);
    }

    protected onRevGameInfo(proto:K9Proto.GameInfo){
        this.eventDispatch('Game_Table_Start');
        super.onRevGameInfo(proto);
        this.view.restStart();
        this.updateTableState(1);
        this.view.roundUI(proto.roundId);
        this.view.updateBaner(this.meIsBank());
        this.view.isShowUpBank(!this.isInQueue() && !this.meIsBank())
        this.checkSeek();
        if (proto.state == 0) {
            this.view.updateTimer(proto.stateExpiredTime-proto.time)
        }
        let rule = ModelData.instance.roomInfo.PlayRuleData;
        if (rule) {
            let betArry = rule.game_BetArr
            this.view.initOperatorBtn(betArry,rule.game_BetSingle);
            //添加事件监听
            for (let btn of this.view.operatorNode.children) {
                btn.on('click',this.clickOperatorNode,this);
            }
        }

        this.bankEntity.onShow(this.model.bankData)

        for (let data of this.model.seatData) {
            let entity = this.getEntity(data.seat_pos);
            entity.updateTime(proto.stateExpiredTime-proto.time,proto.stateDuration,data,proto.state)
        }
        this.bankEntity.updateTime(proto.stateExpiredTime-proto.time,proto.stateDuration,this.model.bankData,proto.state)
    }

    protected onNetMsgEnterNotify(proto:K9Room.IEnterBroadcast){
        super.onNetMsgEnterNotify(proto);
        this.checkSeek();
    }

    protected gameSettle(proto:K9Proto.IGameSettle){
        super.gameSettle(proto);
        //1.输家显示所有输的筹码(下注过程)
        //2.所有输家筹码归池
        //3.赢家获取筹码，并且叠加已经下注的筹码
        //4.筹码飞到自己身上，飞完飘得分(抽水后的分数)
        //5.输家,同时进行
        let count = 0;
        for (let seat of proto.seatList) {
            if (seat.balance<0) {
                count+=seat.balance;
            }
        }
        this.gameoverStep1();
        this.gameoverStep2();
        this.gameoverStep3(count);
        this.gameoverStep4();
        this.gameoverStep5();
        this.updateTableState(1);
        let data = this.getMySeatData();
        if (data && data.state == K9.PlayerState.Settlement) {
            data.balance > 0 ? K9Sound.playWin():K9Sound.playLose();
        }

        //7秒后自动清理
        this.view.stopUserAction(K9.ActionTag.overClear);
        let action = K9Help.delay(this.view.timer,()=>{
            this.onRestart()
        },7)
        action.setTag(K9.ActionTag.overClear);
    }

    protected gameoverStep1(){
        for (let data of this.model.seatData) {
            let entity = this.getEntity(data.seat_pos);
            if (entity) {
                entity.settlementStep1(data);
            }
        }
        this.bankEntity.settlementStep1(this.getBankData())

    }

    protected gameoverStep2(){
        this.view.stopUserAction(K9.ActionTag.step1);
        let action1 = K9Help.delay(this.view.timer,()=>{
            for (let data of this.model.seatData) {
                let entity = this.getEntity(data.seat_pos);
                if (entity) {
                    entity.settlementStep2(data);
                }
            }
            this.bankEntity.settlementStep2(this.getBankData())
        },0.6)
        action1.setTag(K9.ActionTag.step1);
    }

    protected gameoverStep3(count:number){
        this.view.stopUserAction(K9.ActionTag.step2);
        let action2 = K9Help.delay(this.view.timer,()=>{
            for (let data of this.model.seatData) {
                let entity = this.getEntity(data.seat_pos);
                if (entity) {
                    entity.settlementStep3(data,()=>{
                        this.view.updateSidePot(-count);
                    });
                }
            }
            this.bankEntity.settlementStep3(this.getBankData(),()=>{
                this.view.updateSidePot(-count);
            })
        },1.6)
        action2.setTag(K9.ActionTag.step2);
    }

    protected gameoverStep4(){
        this.view.stopUserAction(K9.ActionTag.step3);
        let action3 = K9Help.delay(this.view.timer,()=>{
             //4获取筹码
             let sidePool = this.view.sidePool;
             let pool = sidePool.getPoolData(0);
             if (pool) {
                 sidePool.recycleOneSidePot(0);
             }
             for (let data of this.model.seatData) {
                 let entity = this.getEntity(data.seat_pos);
                 if (entity) {
                     entity.settlementStep4(data);
                 }
             }
             this.bankEntity.settlementStep4(this.getBankData())
        },3)
        action3.setTag(K9.ActionTag.step3);
    }

    protected gameoverStep5(){
        this.view.stopUserAction(K9.ActionTag.step4);
        let action4 = K9Help.delay(this.view.timer,()=>{
             //4漂粉
             for (let data of this.model.seatData) {
                let entity = this.getEntity(data.seat_pos);
                if (entity) {
                    entity.settlementStep5(data);
                }
            }
            this.bankEntity.settlementStep5(this.getBankData())
            this.checkLeaveGame();
        },4)
        action4.setTag(K9.ActionTag.step4);

        let entity = this.getMyEntity();
        if (entity) {
            this.eventDispatch('Game_Table_Settlement',entity.getEffectNode());
        }
    }

    //游戏中主动离开
    private checkLeaveGame(){
        if (ModelData.instance.tableCommonData.autoLeaveWhenGameEnd) {
            this.model.send_Leave()
        }
    }

    checkSeek(){
        let rule = ModelData.instance.roomInfo.PlayRuleData;
        if (rule) {
            let minPeople = rule.pub_MinPlayerNum;
            let bankNumb = 0;
            if (this.model.bankData) {
                if (this.model.bankData.player_id != 0) {
                    bankNumb = 1;
                }
            }
            let count = bankNumb + this.model.seatData.length;
            cc.log('--checkseek',count,minPeople)
            this.eventDispatch('update_seek_player',count,minPeople);
        }
    }

    //预开牌
    protected preopenCardNotify(proto:K9Proto.IPreopenCardNotify){
        super.preopenCardNotify(proto);
        for (let seatData of this.model.seatData) {
            let entity = this.getEntity(seatData.seat_pos);
            entity.updateEntity(seatData.player_id,false)
        }
        this.bankEntity.updateBankEntity(this.model.bankData)
    }

    clickOperatorNode(btn:cc.Button){
        let numb = Number(btn.node.name);
        this.model.send_BetReq(numb)
    }

    @bindButtonClickEvent('zhuang_down')
    downZhuanClick(){
        this.model.send_Banker(false);
    }
    
    @bindButtonClickEvent('zhuang_up')
    openBankerList() {
        let bankers = this.getBankers();
        let isBanker = this.isInQueue();
        ModuleManager.instance.showModule(BankerListModule, { Data: bankers, BtnType: isBanker ? 2:1, Rule: ModelData.instance.roomInfo.PlayRuleData})
    }

    @bindButtonClickEvent('LeaveClick')
    moreGame() {
        ModuleManager.instance.showModule(GameMorePanel);       
    }

    @bindButtonClickEvent('reword_card')
    reword_card() {
        this.model.send_MoreCard(true);
    }

    @bindButtonClickEvent('no_card')
    no_card() {
        this.model.send_MoreCard(false);
    }

    @bindButtonClickEvent('reconnectbtn')
    reconnectbtn() {
        this.model.disconnect();
    }

    protected bankerNotify(proto:K9Proto.IBankerNotify){
         let moveLeft = ()=>{
            if (proto.id != 0) {
                let data = this.findSeatData(proto.id,false);
                if (data) {
                    let entity = this.getEntity(data.seat_pos);
                    if (entity) {
                        entity.changeToBank();
                    }
                }
            }
        }

        let beginCenter = ()=>{
            super.bankerNotify(proto);
            this.bankEntity.onShow(this.model.bankData);
        }

        let overCenter = ()=>{
            if (this.isRole(proto.lastBankerId)) {
                let data = this.getMySeatData();
                if (data) {
                    let viewID = this.getViewID(data.seat_pos);
                    this.realSeatId = data.seat_pos;
                    this.playerSeatViewId(viewID);//玩家坐下
                }
            }
            for (let seat of this.model.seatData) {
                let entity = this.getEntity(seat.seat_pos);
                if (entity) {
                    entity.onShow(seat);
                }
            }
            this.view.updateBaner(this.meIsBank());
            this.view.isShowUpBank(!this.isInQueue() && !this.meIsBank())
            this.sendAck();
        }

        if (this.isRole(proto.lastBankerId)) {//上一任庄家是玩家
            if (proto.reason == 3) {
                this.noEnoughGold();
            }
        }
        if (this.model.commonData.bankId == proto.id) {
            super.bankerNotify(proto);
            this.bankEntity.onShow(this.model.bankData);
            overCenter();
            return;
        }

        this.bankEntity.bankMove(moveLeft,beginCenter,overCenter)
    }

    protected startBroadcast(proto:K9Room.IStartBroadcast){
        super.startBroadcast(proto);
        if (proto.errNo == '0') {
            this.view.roundUI(proto.roundId);
        }
    }

    protected betNotify(proto:K9Proto.IBetNotify){
        super.betNotify(proto);

        if (proto.seatId == 0) {//庄家
            if (this.meIsBank()) {//我是庄家
                this.updateTableState(1);
            }
        }else{
            let entity = this.getEntity(proto.seatId);
            let data = this.findSeatData(proto.seatId);
            if (entity && data) {
                entity.updateEntity(proto.seatId,true)
                if (this.isRole(data.player_id)) {
                    this.updateTableState(1);
                }
            }
        }
        this.bankEntity.updateBankEntity(this.model.bankData);
    }

    protected timeoutNotify(proto:K9Proto.ITimeoutNotify){
        super.timeoutNotify(proto)
        if (proto.event == 1) {//牌局倒计时，下局开始
            this.onRestart();
            this.view.updateTimer(proto.timeout)
            this.eventDispatch('Game_Table_Start');
        }

        if (proto.event == 2
            || proto.event == 5) {
            this.view.isShowTimer(false);
            for (let data of this.model.seatData) {
                let entity = this.getEntity(data.seat_pos);
                entity.updateTime(proto.timeout,proto.totalTimeout,data,proto.event)
            }
            this.bankEntity.updateTime(proto.timeout,proto.totalTimeout,this.model.bankData,proto.event)
        }
    }

    //要牌
    protected moreCardNotify(proto:K9Proto.IMoreCardNotify){
        super.moreCardNotify(proto);
        let entity:K9SeatEntityBase;
        let data = this.findSeatData(proto.seatId);
        if (proto.seatId == 0) {//庄家
            if (this.meIsBank()) {
                this.updateTableState(1);
            }
            entity = this.bankEntity;
            data = this.model.bankData;
            //this.bankEntity.updateBankEntity(this.model.bankData);
        }else{
            entity = this.getEntity(proto.seatId);
            data = this.findSeatData(proto.seatId);
            //entity.updateEntity(data.player_id,false);
        }

        if (entity && data) {
            entity.isBeginCard(true)
            if (this.isRole(data.player_id)) {
                this.updateTableState(1);
                entity.setTime(0,0);
            }

            let updateEntityFunc=(seatId:number,player_id:number,upentity:K9SeatEntityBase)=>{
                if (seatId == 0) {
                    this.bankEntity.updateBankEntity(this.model.bankData);
                }else{
                    upentity.updateEntity(player_id,false);
                }
            }

            if (!proto.noMoreCard) {
                if (proto.card == 0) {
                    entity.dealCards(this.view.cardPos,2,data.cards);//发牌
                    updateEntityFunc(proto.seatId,data.player_id,entity);
                }else{
                    entity.dealBigCards(this.view.cardPos,2,data.cards,true,()=>{
                        updateEntityFunc(proto.seatId,data.player_id,entity);
                        if (this.isRole(data.player_id)) {
                            if (!entity.isK8orK9(data)) {
                                    entity.showPattern(true,data)
                                }
                                this.sendAck();
                            }
                        });
                    }
                }else{
                    updateEntityFunc(proto.seatId,data.player_id,entity);
                }
        }
    }

    getSeatNodeById(playerId: number):cc.Node{
        if (this.isBank(playerId)) {
            return this.bankEntity.getSeatNode();
        }else{
            let data = this.findSeatData(playerId,false);
            if (data) {
                let entity = this.getEntity(data.seat_pos);
                if (entity) {
                    return entity.getSeatNode();
                }
            }
        }
        return null;
    }



    protected dealCardNotify(proto:K9Proto.IDealCardNotify){
        super.dealCardNotify(proto);
        this.updateTableState(1);
        this.bankEntity.beginDealCard();
        for (let seatData of this.model.seatData) {
            let entity = this.getEntity(seatData.seat_pos);
            entity.beginDealCard();
        }
        let haveCards = proto.dealCnt == 2 ? 0 : 2;
        this.dealCardsAction(haveCards,proto.dealCnt)
    }

    protected bankerQueueNotify(proto:K9Proto.IBankerQueueNotify){
        super.bankerQueueNotify(proto);
        //更新上庄列表
        let isInQueue = this.isInQueue();
        this.eventDispatch("event_update_banker", { Data: this.getBankers(), BtnType: isInQueue ? 2:1, Rule:ModelData.instance.roomInfo.PlayRuleData})
        this.view.updateBaner(this.meIsBank());
        this.view.isShowUpBank(!this.isInQueue() && !this.meIsBank())
    }
    
    protected leaveBroadcast(proto:K9Room.ILeaveBroadcast){
        if (!this.isRole(proto.playerId)) {
            if (this.isBank(proto.playerId)) {
                this.bankEntity.onLeave();
            }else{
                let data = this.findSeatData(proto.playerId,false);
                if (data) {
                    let entity = this.getEntity(data.seat_pos);
                    if (entity) {
                        entity.onLeave();
                    }  
                }
            }
        }else{

            if (!joinUtil.checkLeave(proto.reason,this.model.module)) {

                this.exitTable();
            }
        }
        super.leaveBroadcast(proto)
        if (!this.isRole(proto.playerId)) {
            this.checkSeek();
        }
    }

       //发牌 D为中心 顺时针发牌 showCards 显示几张 haveCards 已经显示的牌
    protected dealCardsAction(haveCards:number,showCards:number,cards?:number[]){
        let doActions = this.getEntitysBySort()//this.inGameSeatEntity(true);//参与游戏中的entity[this.getEntityServerID(this.selfServerSeatID)]//
        let count = doActions.length
        if (count <= 0) {//未参与游戏
            return;
        }

        for (let entity of doActions) {
            entity.isBeginCard(true)
        }

        let index = 0;
        let cardIndex = haveCards;
        let repeatTimes = count * (haveCards == 0 ? 2:1) + 1//翻牌结束
        this.view.stopUserAction(K9.ActionTag.dealTimes)
        let actionTimes = K9Help.scheduleTimes(this.view.timer,()=>{
            if (index == count) {
                index = 0;
                if (cardIndex < showCards-1) {
                    cardIndex++;
                }else{
                    //亮牌
                    this.view.stopUserAction(K9.ActionTag.DealCards)
                    let action = K9Help.delay(this.view.timer,()=>{
                        let entity:K9SeatEntityBase;
                        let data = this.getMySeatData();
                        if (data.state != K9.PlayerState.NoInGame) {
                            if (this.meIsBank()) {
                                entity = this.bankEntity;
                            }else{
                                entity = this.getEntity(0,false);
                            }
                            if (entity) {
                                entity.dealOverCards(haveCards,showCards,()=>{
                                    if (!entity.isK8orK9(data)) {
                                        if (data && this.isRole(data.player_id)) {
                                            entity.showPattern(true,data);
                                            this.view.stopUserAction(K9.ActionTag.overdelay)
                                            let act = K9Help.delay(this.view.timer,()=>{
                                                this.sendAck();
                                            },0.3)
                                            act.setTag(K9.ActionTag.overdelay);
                                        }
                                    }else{
                                        this.sendAck();
                                    }
                                });
                            }
                        }
                    },0.4)
                    action.setTag(K9.ActionTag.DealCards);
                    return;
                }
            }

            let present = doActions[index];
            let data:K9.SeatData
            if (present.seatPos == -1) {//庄家
                data = this.model.bankData;
            }else{
                data = this.findSeatData(present.seatPos)
            }

            if (data && present) {
                if (this.isRole(data.player_id)) {
                    present.dealBigCards(this.view.cardPos,cardIndex,data.cards);
                }else{
                    present.dealCards(this.view.cardPos,cardIndex,data.cards);
                }
            }

            index++;
        },0.08,repeatTimes);
        actionTimes.setTag(K9.ActionTag.dealTimes);
    }

    onRestart(){
        super.onRestart();
        this.view.timer.stopAllActions();
        this.view.restartNextRound();
        for (let entity of this.seatEntitys) {
            entity.restartNextRound();
        }
        this.bankEntity.restartNextRound();
        this.checkSeek()
    }

    protected noEnoughGold(){
        let str = LanguageManager.t('Public_ChipInsufficient',true);
        //删除isMangoTable的判断  modif by dred 
        // if (ModelData.instance.tableCommonData.isMangoTable) {
        //     str = LanguageManager.t('Public_MangoInsufficient',true);
        // }
        ModuleManager.instance.toast(str);
    }

    refreshSeatVisible(){
        // this.seatEntitys.forEach((seat:K9SeatEntityBase)=>{
        //     let viewID = this.getViewID(seat.seatPos);
        //     let seatNode = this.seatNode[viewID];
        //     seatNode.active = !seat.isSeat;
        // })
    }

    exitTable(){
        SceneManager.gotoHallOrClubHall("TabelExit");
    }

}
